import { useEffect, useRef } from 'react';

// Local Imports
import WaymarkAuthorWebRenderer from 'shared/WaymarkAuthorWebRenderer';
import * as styles from './ConfiguratorCanvas.css';

interface RendererCanvasProps {
  renderer: WaymarkAuthorWebRenderer;
  id?: string;
}

/**
 * This is a component intended to mirror a rendering
 * Configurator. That is, if you pass it a Configurator, this
 * component will replicate whatever is being drawn by the Configurator
 * into this component's own canvas.
 *
 * @param  {object}     props
 * @param  {class}      props.configurator    - The configurator to replicate onto the canvas.
 * @param  {boolean}    props.isFullscreen    - If the replicator is shown fullscreen, different styles need to be used to stretch the canvas.
 */
export default function RendererCanvas({ renderer, id }: RendererCanvasProps) {
  const canvasParentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const canvasParent = canvasParentRef.current;
    if (!canvasParent || !renderer.view) {
      return;
    }
    canvasParent.replaceChildren(renderer.view);
  }, [renderer.view]);

  return <div ref={canvasParentRef} className={styles.CanvasParent} id={id}></div>;
}
